import {
  ref, watch, onMounted, computed, onUnmounted,
} from 'vue';
import { useStore } from 'vuex';
import { injectLocal, provideLocal } from '@vueuse/core';
import {
  navigationStoreChangeListener,
  pageStoreChangeListener,
  removeStoreChangeListener,
  STORE_CHANGED_ON_HEADER,
  STORE_CHANGED_ON_PAGE,
} from '@common-vue/locator/src/utils/globalStoreChange';
import useMembersOfProduct from '@composables/useMembersOfProduct';
import { getBigTicketZipCookie, getSelectedStoreCookie } from '@utils/cookiesUtils';
import { getStoreLocation } from '../utils';
import { FETCH_AVAILABILITY } from '../../../types/actions';
import { GET_LOAD_STATUS } from '../../../types/getters';
import { FULFILMENT_DATA } from '../consts';

export const useFulfilmentData = () => injectLocal(FULFILMENT_DATA);

export function useFulfilmentDataProvide() {
  const store = useStore();
  const { memberProductIdsString } = useMembersOfProduct();

  const { zipcode: zipcodeLS, store: storeLocationLS } = getStoreLocation();

  const selectedRadioButton = ref('ShipIt');
  const zipCode = ref(getBigTicketZipCookie() || zipcodeLS);
  const storeLocation = ref(storeLocationLS || getSelectedStoreCookie());

  const isDataLoadNeededOnMount = storeLocation.value || zipCode.value;
  const isDataLoaded = computed(() => store.getters[`availabilityStore/${GET_LOAD_STATUS}`]);

  function _fetchAvailability({ detail = { newStore: { locationNumber: '' } } } = {}) {
    const { newStore } = detail;
    storeLocation.value = newStore.locationNumber;

    store.dispatch(`availabilityStore/${FETCH_AVAILABILITY}`, { productId: memberProductIdsString.value, storeLocation: newStore.locationNumber, zipCode: zipCode.value });
  }

  onMounted(() => {
    navigationStoreChangeListener(_fetchAvailability);
    pageStoreChangeListener(_fetchAvailability);

    if (!isDataLoadNeededOnMount) return;
    store.dispatch(`availabilityStore/${FETCH_AVAILABILITY}`, { productId: memberProductIdsString.value, storeLocation: storeLocation.value, zipCode: zipCode.value });
  });

  onUnmounted(() => {
    removeStoreChangeListener(STORE_CHANGED_ON_HEADER, _fetchAvailability);
    removeStoreChangeListener(STORE_CHANGED_ON_PAGE, _fetchAvailability);
  });

  watch(zipCode, (newValue) => {
    store.dispatch(`availabilityStore/${FETCH_AVAILABILITY}`, { productId: memberProductIdsString.value, storeLocation: storeLocation.value, zipCode: newValue });
  });

  provideLocal(FULFILMENT_DATA, {
    zipCode,
    storeLocation,
    selectedRadioButton,
    isDataLoadNeededOnMount,
    isDataLoaded,
  });
}
